export default {
    crop: {
        title: "Sato",
        cropSize: "Satokoko",
        zoom: "Zoom",
        custom: 'Räätälöity',
        post: 'Posti',
        square: 'Neliö',
        landscape: 'Maisema',
        story: 'Tarina',
        portrait: 'Muotokuva',
        carousel: 'Karuselli',
        commonAspectRatio: 'Yleisempi kuvasuhde',
    },
};
